import React from "react";

const StatusAlerts = ({ error, statusMessage, statusColor }) => {
  const colorClasses = {
    success: "bg-green-100 border-green-400 text-green-800",
    error: "bg-red-100 border-red-400 text-red-800",
    warning: "bg-yellow-100 border-yellow-400 text-yellow-800",
    info: "bg-blue-100 border-blue-400 text-blue-800",
  };

  const getAlertClasses = (type) => {
    return `p-4 mt-6 rounded-lg border text-center font-bold ${colorClasses[type] || colorClasses.info}`;
  };

  if (error) {
    return (
      <div className={getAlertClasses("error")} role="alert">
        {error}
      </div>
    );
  }

  if (statusMessage) {
    return (
      <div className={getAlertClasses(statusColor)} role="alert">
        {statusMessage}
      </div>
    );
  }

  return null;
};

export default StatusAlerts;
